module.exports = __webpack_public_path__ + "static/mission-text_1-28dead2ebf5dd670c635bd7b39f23aa4.png";